
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"3.02","height":"4.02","x":"5.97","y":"1","fill":"#000","fill-opacity":".87","fill-rule":"nonzero","rx":".5"}}),_c('rect',{attrs:{"width":"3.02","height":"4.02","x":"15.02","y":"1","fill":"#000","fill-opacity":".87","fill-rule":"nonzero","rx":".5"}}),_c('rect',{attrs:{"width":"20.1","height":"5.53","x":"1.95","y":"3.9","fill":"#FAB4CD","fill-rule":"nonzero","rx":"1.32"}}),_c('rect',{attrs:{"width":"20.1","height":"19.1","x":"1.95","y":"3.9","stroke":"#000","rx":"1.96"}}),_c('path',{attrs:{"fill":"#5CE8AD","fill-rule":"nonzero","d":"M15.92 15.56v1.12c0 .31-.25.56-.56.56h-2.24v2.24c0 .31-.25.56-.56.56h-1.12a.56.56 0 01-.56-.56v-2.24H8.64a.56.56 0 01-.56-.56v-1.12a.56.56 0 01.56-.56h2.24v-2.24c0-.31.25-.56.56-.56h1.12c.31 0 .56.25.56.56V15h2.24c.31 0 .56.25.56.56z"}}),_c('path',{attrs:{"stroke":"#000","d":"M1.95 9.43h20.1"}})])])
          )
        }
      }
    